export enum ModalClass {
    MODAL_SMALL = 'modal-sm modal-dialog-scrollable modal-fullscreen-lg-down',
    MODAL_MEDIUM = 'modal-md modal-dialog-scrollable modal-fullscreen-lg-down',
    MODAL_LARGE = 'modal-lg modal-dialog-scrollable modal-fullscreen-lg-down',
    MODAL_EXTRA_LARGE = 'modal-xl modal-dialog-scrollable modal-fullscreen-xl-down',
    MODAL_SMALL_NO_FULLSCREEN = 'modal-sm modal-dialog-scrollable',
    MODAL_MEDIUM_NO_FULLSCREEN = 'modal-md modal-dialog-scrollable',
    MODAL_LARGE_NO_FULLSCREEN = 'modal-lg modal-dialog-scrollable',
    MODAL_FULLSCREEN = 'modal-fullscreen modal-dialog-scrollable',
}
